import logo from 'assets/images/kinderwens_logo.png';
import logoPayoff from 'assets/images/kinderwens_payoff.png';
import defaultConfigs from './default';

const AWS = {
  aws_project_region: 'eu-west-1',
  aws_cognito_identity_pool_id:
    'eu-west-1:b9d8edea-47c6-4c5b-96f1-993e29d8fb92',
  aws_cognito_region: 'eu-west-1',
  aws_user_pools_id: 'eu-west-1_VstU5moqk',
  aws_user_pools_web_client_id: 'au0b9as59r76n10lkfggu222',
  oauth: {},
  aws_cognito_username_attributes: ['EMAIL'],
  aws_cognito_social_providers: [],
  aws_cognito_signup_attributes: ['EMAIL'],
  aws_cognito_mfa_configuration: 'OPTIONAL',
  aws_cognito_mfa_types: ['SMS'],
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: '8',
    passwordPolicyCharacters: ['REQUIRES_NUMBERS'],
  },
  aws_cognito_verification_mechanisms: ['EMAIL'],
  aws_appsync_graphqlEndpoint:
    'https://qbfgwj43grgefcs2mq67nuby3q.appsync-api.eu-west-1.amazonaws.com/graphql',
  aws_appsync_region: 'eu-west-1',
  aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
  aws_cloud_logic_custom: [
    {
      name: 'userapi',
      endpoint:
        'https://qqp68riacg.execute-api.eu-west-1.amazonaws.com/childwish',
      region: 'eu-west-1',
    },
  ],
  aws_user_files_s3_bucket: 'clinicardstorage92242-childwish',
  aws_user_files_s3_bucket_region: 'eu-west-1',
  aws_cognito_login_mechanisms: ['EMAIL'],
  Auth: {
    cookieStorage: {
      domain:
        process.env.NODE_ENV === 'production'
          ? 'kinderwens.clinicards.app'
          : 'localhost',
      path: '/',
      expires: 1,
      secure: process.env.NODE_ENV === 'production',
    },
  },
};

const defaultCarepathCards = [];

export default {
  ...defaultConfigs,
  APP_TITLE: 'Kinderwens',
  APP_CODE: 'CLIN-APP-0019',
  ENABLE_ARTICLES: true,
  ENABLE_OPERATION_PROFILE: true,
  ENABLE_PERMISSIONS: true,
  ENABLE_MANAGEMENT: true,
  ENABLE_ORGANISATION_LEVEL: true,
  ENABLE_ORGANISATION_MULTIPLE: true,
  ENABLE_CAREPATH: true,
  ENABLE_CARDS: true,
  ENABLE_STACKED_CAREPATH: true,
  AWS,
  defaultCarepathCards,
  logo,
  logoPayoff,
};
